module.exports = __webpack_public_path__ + "static/media/copy_icon.76053676.svg";